<!-- 公告 -->
<template>
    <DraggableDialog ref="draggableDialog" title="公告信息" :visible.sync="showDialog" :closeOnEsc="false"
        :closeOnClickMask="false" :fullscreen="false" @close="handleClose" :width="760" :height="560">
        <div class="notice-panel">
            <div class="notice-alert notice-alert--low-sales">
                <div class="notice-alert__badge">重要通知</div>
                <h2 class="notice-alert__headline">抖音动销率考核说明</h2>
                <p class="notice-alert__highlight">
                    因<strong>抖音平台政策调整</strong>，平台将<strong>考核店铺动销率</strong>。
                    低动销店铺暂不可发新商品，系统将<strong>自动清理无销量、无流量商品</strong>。
                </p>
                <p class="notice-alert__subline">
                    若您的商品已被<strong>系统自动下架</strong>，请于<strong>周六</strong>在抖店后台<strong>重新上架</strong>，以免影响店铺动销考核与正常经营。
                </p>
                <ul class="notice-alert__points">
                    <li>
                        <span class="notice-alert__point-tag notice-alert__point-tag--warn">平台考核</span>
                        <span>抖音将考核店铺动销率；低动销店铺暂不可发品，请通过清理无销量商品、提升动销恢复上货。</span>
                    </li>
                    <li>
                        <span class="notice-alert__point-tag notice-alert__point-tag--clean">自动清理</span>
                        <span>低动销店铺将<strong>自动清理</strong>出售中<strong>无销量、无流量</strong>的商品（有销量商品不会下架）。</span>
                    </li>
                    <li>
                        <span class="notice-alert__point-tag notice-alert__point-tag--info">周六上架</span>
                        <span>如有被下架商品，请<strong>周六</strong>在抖店后台<strong>重新拉上架</strong>，避免影响动销率统计。</span>
                    </li>
                    <li>
                        <span class="notice-alert__point-tag notice-alert__point-tag--safe">如何查看</span>
                        <span>请前往 <strong class="notice-alert__link">账号列表</strong>，查看「发品额度 → 动销」：
                            显示 <strong class="notice-alert__ok">正常</strong> 表示非低动销，可正常上货。</span>
                    </li>
                </ul>
                <p class="notice-alert__footer">
                    请各店铺<strong>保持好动销率</strong>，及时清理无销量商品；被下架的请<strong>周六再拉上架</strong>，避免触发低动销限制。
                </p>
            </div>
        </div>
        <div slot="footer" class="cont-footer">
            <el-button type="text" size="mini" @click="nextTimeShow">今日不在提醒</el-button>
            <el-button type="primary" size="mini" @click="handleClose">我已知晓</el-button>
        </div>
    </DraggableDialog>
</template>

<script>
import DraggableDialog from '@/components/settings/DraggableDialog.vue';
import wechat from '@/assets/img/wechat.jpg';
export default {
    components: {
        DraggableDialog,
    },
    data() {
        return {
            showDialog: false,
            weChatJpg: wechat,
            noticeStorageKey: 'nextTimeShow_low_sales_quota_notice_20260827',
        };
    },
    computed: {
        site: function () {
            return this.$store.state.site.siteInfo;
        },
        longcheng: function () {
            return this.site?.name == 'longcheng';
        },
    },
    created() {
        this.getShowModal();
    },
    methods: {
        getShowModal() {
            let nextTime = localStorage.getItem(this.noticeStorageKey);
            if (nextTime > 0 && Date.now() < nextTime) {
                this.showDialog = false;
                this.$nextTick(() => this.$emit("done"));
                return;
            }
            this.showDialog = true;
        },
        nextTimeShow() {
            let today = new Date();
            today.setDate(today.getDate() + 1);
            today.setHours(0, 0, 0, 0);
            localStorage.setItem(this.noticeStorageKey, new Date(today).getTime());
            this.handleClose();
        },
        handleClose() {
            this.showDialog = false;
            this.$emit("close");
            this.$emit("done");
        }
    }
}
</script>

<style scoped>
.notice-panel {
    height: 100%;
    padding: 8px 10px 12px;
    overflow-y: auto;
    box-sizing: border-box;
}
.notice-alert {
    position: relative;
    padding: 22px 20px 20px;
    border-radius: 12px;
    background: linear-gradient(180deg, #fff5f5 0%, #fff 58%);
    border: 2px solid #f56c6c;
    box-shadow: 0 6px 20px rgba(245, 108, 108, 0.22);
}
.notice-alert--low-sales {
    background: linear-gradient(180deg, #fff1f0 0%, #fffbeb 42%, #fff 100%);
    border-color: #f5222d;
}
.notice-alert__badge {
    display: inline-block;
    margin-bottom: 12px;
    padding: 4px 12px;
    font-size: 12px;
    font-weight: 700;
    line-height: 20px;
    letter-spacing: 1px;
    color: #fff;
    background: linear-gradient(90deg, #f5222d, #f56c6c);
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(245, 34, 45, 0.35);
}
.notice-alert__headline {
    margin: 0 0 14px;
    font-size: 22px;
    font-weight: 800;
    line-height: 1.35;
    color: #cf1322;
    letter-spacing: 0.5px;
}
.notice-alert__highlight {
    margin: 0 0 16px;
    padding: 14px 16px;
    font-size: 15px;
    font-weight: 600;
    line-height: 1.75;
    color: #434343;
    background: #fff;
    border: 2px dashed #ff7875;
    border-radius: 8px;
}
.notice-alert__highlight strong {
    color: #cf1322;
    font-weight: 800;
}
.notice-alert__subline {
    margin: 0 0 16px;
    padding: 12px 14px;
    font-size: 14px;
    font-weight: 700;
    line-height: 1.75;
    color: #ad4e00;
    background: #fff7e6;
    border-left: 4px solid #fa8c16;
    border-radius: 6px;
}
.notice-alert__subline strong {
    color: #d4380d;
}
.notice-alert__points {
    margin: 0 0 16px;
    padding: 0;
    list-style: none;
}
.notice-alert__points li {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    margin-bottom: 14px;
    padding: 12px 14px;
    font-size: 14px;
    line-height: 1.75;
    color: #303133;
    background: #fff;
    border: 1px solid #ffe7ba;
    border-radius: 8px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);
}
.notice-alert__points li:last-child {
    margin-bottom: 0;
    border-color: #b7eb8f;
    background: linear-gradient(90deg, #fff 0%, #f6ffed 100%);
}
.notice-alert__point-tag {
    flex-shrink: 0;
    margin-top: 2px;
    padding: 2px 8px;
    font-size: 12px;
    font-weight: 700;
    line-height: 20px;
    color: #fff;
    border-radius: 4px;
    white-space: nowrap;
}
.notice-alert__point-tag--warn {
    background: #f5222d;
}
.notice-alert__point-tag--info {
    background: #1890ff;
}
.notice-alert__point-tag--safe {
    background: #52c41a;
}
.notice-alert__point-tag--clean {
    background: #fa8c16;
}
.notice-alert__link {
    color: #1890ff;
    font-weight: 700;
}
.notice-alert__ok {
    color: #389e0d;
    font-weight: 800;
}
.notice-alert__footer {
    margin: 0;
    padding: 14px 16px;
    font-size: 15px;
    font-weight: 700;
    line-height: 1.75;
    color: #cf1322;
    text-align: center;
    background: #fff1f0;
    border-radius: 8px;
    border: 1px solid #ffa39e;
}
.cont-footer {
    text-align: right;
}
</style>
